import { FC, ReactElement, memo } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { useGetAllExternalRedirectsQuery } from '@/modules/ExternalRedirects';

import { ExternalRedirectsListView } from './ExternalRedirectsListView';

interface Props {
  siteId: string;
}

export const ExternalRedirectsListContainer: FC<Props> = memo(({ siteId }) => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const {
    data: externalRedirectsListData,
    error: externalRedirectsListError,
    isLoading: isExternalRedirectsListLoading,
    isFetching: isExternalRedirectsListFetching,
    isError: isExternalRedirectsListError
  } = useGetAllExternalRedirectsQuery(siteId, { page: currentPage })();

  return (
    <FallbackedLayout
      isLoading={ isExternalRedirectsListLoading }
      error={ externalRedirectsListError }
      isError={ isExternalRedirectsListError }
      data={ externalRedirectsListData }
    >
      { (externalRedirectsList): ReactElement => (
        <ExternalRedirectsListView
          siteId={ siteId }
          currentPage={ currentPage }
          externalRedirectsListItems={ externalRedirectsList.items }
          externalRedirectsListTotalItems={ externalRedirectsList.meta.totalItems }
          externalRedirectsListItemsPerPage={ externalRedirectsList.meta.itemsPerPage }
          isLoading={ isExternalRedirectsListFetching }
          handleChangePage={ handleChangePage }
        />
      ) }
    </FallbackedLayout>
  );
});
